import React, {useEffect, useState} from 'react';
import {SSRProvider} from '@react-aria/ssr'; // handles warning from FormControl
import {Helmet} from 'react-helmet';

import GuidelinesModal from 'routes/Products/components/GuidelinesModal/';
import GeneralModal from 'components/GeneralModal';
import Profile from 'routes/User/Profile/containers';
import {CommunicationPreferences} from 'routes/User/Profile/components/CommunicationPreferences';

// library imports
import {AppContextProvider} from '@frn/frn-react-native-discourse/lib/module/context/AppContextProvider';
import ContentItemComments from '@frn/frn-react-native-discourse/lib/module/components/Forum/ContentItemComments';
import Forum from '@frn/frn-react-native-discourse/lib/module/components/Forum/Forum';
import {forumInterfaceFunctions} from '@frn/frn-react-native-discourse/lib/module/components/hooks/forumInterfaceFunctions';

const baseEnvVars = {
  FORUM_BASE_URL: process.env.FORUM_BASE_URL,
  FORUM_API_URL: process.env.FORUM_API_URL,
  FORUM_DISCOURSE_API_USERNAME_PREFIX: process.env.FORUM_DISCOURSE_API_USERNAME_PREFIX,
  FORUM_GROUP_PM_OPTED_OUT_ID: process.env.FORUM_GROUP_PM_OPTED_OUT_ID,
  FORUM_GROUP_PM_OPTED_OUT_NAME: process.env.FORUM_GROUP_PM_OPTED_OUT_NAME
};

const ForumWrapper = props => (
  <>
    <Helmet>
      <script src="https://cdn.foodrevolution.org/scripts/message-bus-ajax.min.js" type="text/javascript"></script>
    </Helmet>
    <SSRProvider>
      <AppContextProvider>
        <ForumWrapperInner {...props} />
      </AppContextProvider>
    </SSRProvider>
  </>
);

const ForumWrapperInner = props => {
  const [isGuidelineModalOpen, setIsGuidelineModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [profileUserId, setProfileUserId] = useState(null);

  const envVars = {
    ...baseEnvVars,
    PRODUCT: props.product
  };

  envVars.IS_OUTSIDE_FORUM = props.forumType == 'Forum' ? false : true;

  // platform only: hide medical disclaimer
  const StyleBlock = () => {
    return (
      <style>{`
            .medicalDisclaimer{display:none;}
          `}</style>
    );
  };

  useEffect(() => {
    //modal needs the publicProfileUserId before it is shown
    if (profileUserId) {
      if (isProfileModalOpen) setProfileUserId(null); // reset upon close
      setIsProfileModalOpen(!isProfileModalOpen);
    }
  }, [profileUserId]);

  //used to show the user profile modal
  const toggleModal = (publicProfileUserId, force) => {
    if (force === 'close') {
      setIsProfileModalOpen(false);
      return;
    }
    setProfileUserId(publicProfileUserId);
  };

  // simple url parse routine
  const urlToPath = () => {
    let path = null;
    const urlParts = location.hash.split('/');
    if (urlParts[1] === 'topic' || 'reply') {
      if (urlParts[2]) {
        path = {
          post: urlParts[1],
          id: urlParts[2]
        };
      }
    }
    return path;
  };

  return (
    <>
      {profileUserId && (
        <GeneralModal
          isOpen={isProfileModalOpen}
          toggle={toggleModal}
          component={() => {
            return <Profile publicProfileUserId={profileUserId} showSummary={true} toggleModal={toggleModal} />;
          }}
        />
      )}
      {props.forumType == 'Forum' ? (
        <>
          <GuidelinesModal
            isOpen={isGuidelineModalOpen}
            toggle={() => setIsGuidelineModalOpen(!isGuidelineModalOpen)}
          />
          <Forum
            {...props}
            forumKey={{path: urlToPath()}}
            isGuidelineModalOpen={isGuidelineModalOpen}
            setIsGuidelineModalOpen={setIsGuidelineModalOpen}
            toggleProfileModal={toggleModal}
            envVars={envVars}
          />
          <StyleBlock />
        </>
      ) : (
        <ContentItemComments
          {...props}
          forumKey={{path: urlToPath()}}
          toggleProfileModal={toggleModal}
          envVars={envVars}
        />
      )}
    </>
  );
};

export {baseEnvVars, ForumWrapper};
